import { render, staticRenderFns } from "./OrderProductsTable.vue?vue&type=template&id=7dbd3e50&scoped=true&"
import script from "./OrderProductsTable.vue?vue&type=script&lang=js&"
export * from "./OrderProductsTable.vue?vue&type=script&lang=js&"
import style0 from "./OrderProductsTable.vue?vue&type=style&index=0&id=7dbd3e50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbd3e50",
  null
  
)

export default component.exports